import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DollarSign, TrendingUp, FileText, PieChart } from "lucide-react";
import { RevenueTracking } from "@/components/accounting/RevenueTracking";
import { ProfitLoss } from "@/components/accounting/ProfitLoss";
import { AccountingReports } from "@/components/accounting/AccountingReports";
import { RevenueForecast } from "@/components/accounting/RevenueForecast";

export default function Accounting() {
  const [activeTab, setActiveTab] = useState("revenue");

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Financial Management</h1>
        <p className="text-muted-foreground">Track revenue, expenses, and financial health</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="revenue">
            <DollarSign className="mr-2 h-4 w-4" />
            Revenue
          </TabsTrigger>
          <TabsTrigger value="profitloss">
            <TrendingUp className="mr-2 h-4 w-4" />
            P&L
          </TabsTrigger>
          <TabsTrigger value="forecast">
            <PieChart className="mr-2 h-4 w-4" />
            Forecast
          </TabsTrigger>
          <TabsTrigger value="reports">
            <FileText className="mr-2 h-4 w-4" />
            Reports
          </TabsTrigger>
        </TabsList>

        <TabsContent value="revenue">
          <RevenueTracking />
        </TabsContent>

        <TabsContent value="profitloss">
          <ProfitLoss />
        </TabsContent>

        <TabsContent value="forecast">
          <RevenueForecast />
        </TabsContent>

        <TabsContent value="reports">
          <AccountingReports />
        </TabsContent>
      </Tabs>
    </div>
  );
}